class Cases {
  constructor() {
    this.breakpoints = [768, 1440];
    this.increments = [2, 4, 6];
    this.initTileDisplay = [7, 8, 9];
    this.cases = document.querySelectorAll('.case-tile');
    this.moreBtn = document.querySelector('.cases__more');
    this.currentTiles = this.widthBasedLookup(this.initTileDisplay);
    this.increment = this.widthBasedLookup(this.increments);
    this.init();
  }

  init() {
    if (this.cases.length > this.currentTiles) {
      this.addButton();
      this.removeCases();
      this.buttonListener();
      this.resizeListener();
    }
  }

  widthBasedLookup(arr) {
    if (window.innerWidth <= this.breakpoints[0]) {
      return arr[0];
    } if (window.innerWidth <= this.breakpoints[1]) {
      return arr[1];
    }
    return arr[2];
  }

  addButton() {
    this.moreBtn.style.display = 'flex';
  }

  removeButton() {
    this.moreBtn.style.display = 'none';
  }

  removeCases() {
    for (let i = this.currentTiles; i < this.cases.length; i += 1) {
      this.cases[i].style.display = 'none';
    }
  }

  addCases() {
    for (let j = this.currentTiles;
      j < this.cases.length && j < this.currentTiles + this.increment;
      j += 1
    ) {
      this.cases[j].style.display = 'flex';
    }
    this.currentTiles += this.increment;
  }

  buttonListener() {
    this.moreBtn.addEventListener('click', () => {
      this.addCases();
    });
  }

  resizeListener() {
    window.addEventListener('resize', () => {
      this.increment = this.widthBasedLookup(this.increments);
      if (this.increment === this.increments[2] && this.currentTiles % 3 === 2) {
        this.cases[this.currentTiles].style.display = 'flex';
        this.currentTiles += 1;
      }
    });
  }
}

Cases();
